<template>
  <div class="bank_wrap bg_white pl16 pr16 pt15 pb15 mt12">
    <h2 class="page_title ab c5a">{{ !confirm ? 'ゆうちょ銀行' : '確認画面' }}</h2>

    <dl class="bank_form">
      <div class="form_list">
        <dt class="form_title ar">通帳記号</dt>
        <dd class="form_contents">
          <span class="error ab">{{ error.postOfficeSign }}</span>
          <input v-if="!confirm" class="bank_input c5a rb" type="tel" maxlength="5" v-model="bankAccount.postOfficeSign" name="postOfficeSign" @keyup="postOfficeSignKeyUpHalfSizeRestriction" value="">
          <div v-else class="bank_input rb">{{ bankAccount.postOfficeSign }}</div>
        </dd>
      </div>
      <div class="form_list">
        <dt class="form_title ab">通帳番号</dt>
        <dd class="form_contents">
          <span class="error ab">{{ error.postOfficeNumber }}</span>
          <input v-if="!confirm" class="bank_input c5a rb" type="tel" maxlength="8" v-model="bankAccount.postOfficeNumber" name="postOfficeNumber" @keyup="postOfficeNumberKeyUpHalfSizeRestriction" value="">
          <div v-else class="bank_input rb">{{ bankAccount.postOfficeNumber }}</div>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  props: ['bankAccount', 'confirm', 'error'],
  methods: {
    charaLimit(inputText, count) {
      return inputText.length > count ? inputText.slice(0, -1) : inputText;
    },
    postOfficeSignKeyUpHalfSizeRestriction() {
      console.log('postOfficeSignKeyUpHalfSizeRestriction');
      let tmp_value = this.bankAccount.postOfficeSign;
      if(tmp_value){
        this.bankAccount.postOfficeSign = tmp_value.replace(/[^0-9]/g,'');
      }
    },
    postOfficeNumberKeyUpHalfSizeRestriction() {
      console.log('postOfficeNumberKeyUpHalfSizeRestriction');
      let tmp_value = this.bankAccount.postOfficeNumber;
      if(tmp_value){
        this.bankAccount.postOfficeNumber = tmp_value.replace(/[^0-9]/g,'');
      }
    },
  },
  watch: {
    'bankAccount.postOfficeSign': function(val) {
      // this.bankAccount.postOfficeSign = this.charaLimit(val, 5);
      // this.yuchoKeyUpHalfSizeRestriction(this.bankAccount.postOfficeSign);
    },
    'bankAccount.postOfficeNumber': function(val) {
      // this.bankAccount.postOfficeNumber = this.charaLimit(val, 8);
      // this.yuchoKeyUpHalfSizeRestriction(this.bankAccount.postOfficeNumber);
    }
  }
}
</script>

<style lang="css" scoped>
.form_list {
  margin-top: 30px;
}
.form_title {
  color: #878787;
  font-size: 12px;
}
.bank_input {
  border: none;
  border-bottom: 1px solid  #c9c9c9;
  font-size: 16px;
  margin-top: 5px;
  padding-bottom: 10px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/Yucho.vue